module.exports = require("./es-PH.js");